import { useState } from 'react';
import type { CSSProperties } from 'react';
import Popover from '@mui/material/Popover';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { ReactComponent as InfoIcon } from 'assets/icons/information.svg';
import IconBtn from 'components/common/IconBtn';
import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';

const StyledInfoIcon = styled(InfoIcon)<{
    color: string;
    height: string;
    width: string;
}>`
    height: ${({ height }) => height};
    width: ${({ width }) => width};

    path {
        fill: ${({ color }) => color};
    }
`;

const StyledPopover = styled.div`
    ${TextStyle({ fontSize: '12px', fontWeight: '400' })}
`;

type InfoPopoverProps = {
    translationText: string;
    iconHeight: string;
    iconWidth: string;
    iconColor: string;
    popoverStyle: CSSProperties;
};

const InfoPopover = ({
    translationText,
    iconHeight,
    iconWidth,
    iconColor,
    popoverStyle,
}: InfoPopoverProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <IconBtn
                onClick={(event) => {
                    handleClick(event);
                }}
                style={{
                    padding: '0px',
                }}
            >
                <StyledInfoIcon height={iconHeight} width={iconWidth} color={iconColor} />
            </IconBtn>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <StyledPopover style={{ ...popoverStyle }}>
                    {t(translationText, { lng: language })}
                </StyledPopover>
            </Popover>
        </>
    );
};

export default InfoPopover;
